import { combineReducers } from 'redux';

// Common
import UserReducers from './common/UserReducers';
import MeReducers from './common/MeReducers';
// Feature
import CustomerReducer from './features/CustomerReducer';
import CustomerTypeReducer from './features/CustomerTypeReducer';

import DepartmentReducer from './features/DepartmentReducer';
import RoleTypesReducer from './features/RoleTypesReducer';
import EmployeeReducer from './features/EmployeeReducer';
import InformationReducer from './features/InformationReducer';
import MaterialTypeReducer from './features/MaterialTypeReducer';
// IMS
import MaterialReducer from './features/MaterialReducer';
import MaterialTransactionTypeReducer from './features/MaterialTransactionTypeReducer';
import PlaceReducer from './features/PlaceReducer';
import LogTransactionAction from './features/LogTransactionReducer';
import MaterialTransactionReducer from './features/MaterialTransactionReducer';
import MaterialStockLotReducer from './features/MaterialStockLotReducer';
import MaterialWithdrawReducer from './features/MaterialWithdrawReducer';
import NotifyReducer from './features/NotifyReducer';
import MaterialRequestReducer from './features/MaterialRequestReducer';
import GoldTransactionReducer from './features/GoldTransactionReducer';
import GoldPriceReducer from './features/GoldPriceReducer';
import CommentReducer from './features/CommentReducer';
import ProcessTransactionReducer from './features/ProcessTransactionReducer';
import ProcessMaterialReducer from './features/ProcessMaterialReducer';
import GoldReportReducer from './features/GoldReportReducer';
import LogTransactionReducer from './features/LogTransactionReducer';
import paymentOtherReducer from './features/paymentOtherReducer';
import DaySummaryReducer from './features/DaySummaryReducer';
import MonthSumReducer from './features/MonthSumReducer';
import BankReducer from './features/BankReducer';
import DaySummaryListReducer from './features/DaySummaryListReducer';
import FinanceReducer from './features/FinanceReducer';

const rootRuducer = combineReducers({
  me: MeReducers,
  comments: CommentReducer,
  customer: CustomerReducer,
  customerType: CustomerTypeReducer,
  department: DepartmentReducer,
  employee: EmployeeReducer,
  information: InformationReducer,
  gold: GoldTransactionReducer,
  daySummary: DaySummaryReducer,
  daySummaryList: DaySummaryListReducer,
  monthSum: MonthSumReducer,
  bank: BankReducer,
  logtransaction: LogTransactionReducer,
  material: MaterialReducer,
  goldprice: GoldPriceReducer,
  goldReport: GoldReportReducer,
  materialRequest: MaterialRequestReducer,
  materialStockLot: MaterialStockLotReducer,
  materialTransaction: MaterialTransactionReducer,
  materialTransactionType: MaterialTransactionTypeReducer,
  materialType: MaterialTypeReducer,
  materialWithdraw: MaterialWithdrawReducer,
  notify: NotifyReducer,
  place: PlaceReducer,
  processMaterials: ProcessMaterialReducer,
  processTransactions: ProcessTransactionReducer,
  roletype: RoleTypesReducer,
  user: UserReducers,
  paymentOther: paymentOtherReducer,
  finance: FinanceReducer,
});
export default rootRuducer;
